var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignShift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000976562 18.5625L3.41504 21.9678L4.38184 21.001L2.63086 19.25H9.22656V17.875H2.63086L4.38184 16.124L3.41504 15.1572L-0.000976562 18.5625ZM6.70215 20.625L5.32715 22H18.8516V2.75H13.3516C13.3516 2.37044 13.2799 2.01595 13.1367 1.68652C12.9935 1.3571 12.7965 1.06348 12.5459 0.805664C12.2952 0.547852 12.0052 0.350911 11.6758 0.214844C11.3464 0.078776 10.9883 0.00716146 10.6016 0C10.222 0 9.86751 0.0716146 9.53809 0.214844C9.20866 0.358073 8.91504 0.555013 8.65723 0.805664C8.39941 1.05632 8.20247 1.34635 8.06641 1.67578C7.93034 2.00521 7.85872 2.36328 7.85156 2.75H2.35156V14.2764L3.72656 12.9014V4.125H5.10156V6.875H16.1016V4.125H17.4766V20.625H6.70215ZM14.7266 4.125V5.5H6.47656V4.125H9.22656V2.75C9.22656 2.55664 9.26237 2.3776 9.33398 2.21289C9.4056 2.04818 9.50228 1.90495 9.62402 1.7832C9.74577 1.66146 9.89258 1.5612 10.0645 1.48242C10.2363 1.40365 10.4154 1.36784 10.6016 1.375C10.7949 1.375 10.974 1.41081 11.1387 1.48242C11.3034 1.55404 11.4466 1.65072 11.5684 1.77246C11.6901 1.89421 11.7904 2.04102 11.8691 2.21289C11.9479 2.38477 11.9837 2.5638 11.9766 2.75V4.125H14.7266Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignShift);
export default __webpack_public_path__ + "static/media/assignShift.cf83f9986e18054e8ad1ab3568e6f6da.svg";
export { ForwardRef as ReactComponent };